'use strict';

import Vue from 'vue';
import { JsBridge, ActUtils as _ } from '@ie-activity/oversea-act-js-lib'
import * as Types from '@src/store/types';
import * as System from '@src/utils/system';

const state = {
    // 通用资源
    rules: '',

    // 抽奖专用
    awards: [],
    lotteryChance: 0,
    lotteryType: null, // 商店和游戏: 1表示下载 2表示打开 3表示打开和下载 4积分购买 5充值抽奖
    lotteryCost: null, // 抽奖消耗，仅lotteryType = 4有效

    // 加载资源
    loaded: 0,
    total: 100,
    isFinishLoad: false,
    hasFetchInfo: false
};

const mutations = {
    [Types.SET_COMMON_INFO](state, params) {
        for (let key in params) {
            Vue.set(state, key, params[key]);
        }
    }
};

const actions = {
    /**
     * 获取页面数据
     * */
    [Types.FETCH_PAGE_INFO]({ state, commit }) {
        let fetchPromise;

        // 测试环境通过接口活动数据，正式环境通过页面中注入的pageData对象来获取数据
        if (System.isDev) {
            fetchPromise = _.jsonpFn({
                url: `${System.actDomain}/activity-admin/homepage`,
                data: {
                    actId: _.getActId()
                }
            });
        } else {
            let res = window.pageData || {};
            if (res.code === '1001') {
                fetchPromise = Promise.resolve(res);
            } else {
                fetchPromise = Promise.reject(res);
            }
        }

        return fetchPromise.then(
            (res) => {
                console.log('pageData:', res);

                let pageMap = res.pageMap || {};
                let appMap = res.appMap;

                // 默认APP列表
                for (let key in appMap) {
                    if (_.isArray(appMap[key])) {
                        let appIds = [];
                        for (let i = 0; i < appMap[key].length; i++) {
                            appIds.push(appMap[key][i].appId);
                            commit(Types.SET_APP_INFO, appMap[key][i]);
                        }
                        commit(Types.APPEND_APP_LIST, {
                            type: 'default',
                            appIds
                        });
                    }
                }

                // 规则
                commit(Types.SET_COMMON_INFO, {
                    rules: pageMap.actRule || ''
                });
                return Promise.resolve(res);
            },
            (res) => {
                JsBridge.makeToast(res.msg);
                return Promise.resolve(res);
            }
        );
    },

    /**
     * 预加载资源
     * */
    [Types.PRELOAD_IMGS]({ state, commit }, { images }) {
        commit(Types.SET_COMMON_INFO, {
            total: images.length
        });

        let queue = [];
        images.forEach((imgSrc) => {
            queue.push(
                new Promise((resolve) => {
                    let img = new Image();
                    img.onload = img.onerror = () => {
                        commit(Types.SET_COMMON_INFO, { loaded: state.loaded + 1 });
                        resolve();
                    };
                    img.src = imgSrc;
                })
            );
        });

        return Promise.all(queue);
    }
};

export default {
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/common.js